/**
 * 用户接口
 * 用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The CompanyLoginForm model module.
   * @module account/model/CompanyLoginForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>CompanyLoginForm</code>.
   * @alias module:account/model/CompanyLoginForm
   * @class
   * @param token {String} ticket
   * @param companyId {Integer} 公司id
   */
  var exports = function(token, companyId) {
    var _this = this;

    _this['token'] = token;
    _this['companyId'] = companyId;
  };

  /**
   * Constructs a <code>CompanyLoginForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:account/model/CompanyLoginForm} obj Optional instance to populate.
   * @return {module:account/model/CompanyLoginForm} The populated <code>CompanyLoginForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'token')) {
        obj['token'] = ApiClient.convertToType(data['token'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'companyId')) {
        obj['companyId'] = ApiClient.convertToType(data['companyId'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * ticket
   * @member {String} token
   */
  exports.prototype['token'] = undefined;
  /**
   * 公司id
   * @member {Integer} companyId
   */
  exports.prototype['companyId'] = undefined;



  export default exports;
;


